import React from "react";
import Bugsnag from "@bugsnag/browser";
import calendar from "../../ui/icons/calendar.png";
import map from "../../ui/icons/map.png";
import smartphoneCall from "../../ui/icons/smartphone-call.png";
import viber from "../../ui/icons/viber.png";
import { primary } from "../../ui/colors";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { useMemo } from "react";
import useMobile from "../../hooks/useOrientation";

const primaryDark = "#00a896";
const primaryLight = "#e0faf7";

const CONTACT_ITEMS = [
  {
    icon: map,
    label: "Dirección",
    value: "Av Brasil 3150, Montevideo, Uruguay",
    link: null,
  },
  {
    icon: viber,
    label: "Teléfono",
    value: "27088888",
    link: null,
  },
  {
    icon: calendar,
    label: "Horario",
    value: "Lunes a Viernes · 10:00 a 19:00 hs",
    link: null,
  },
  {
    icon: smartphoneCall,
    label: "WhatsApp",
    value: "Escribinos por WhatsApp",
    link: "https://api.whatsapp.com/send?phone=59892655343",
  },
];

export default function Contact() {
  const isMobile = useMobile();

  return (
    <div style={{ ...styles.container, padding: isMobile ? "16px 12px" : "24px 20px" }}>
      <h1 style={styles.pageTitle}>Contacto</h1>

      <div style={{ ...styles.grid, gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr" }}>
        {CONTACT_ITEMS.map(({ icon, label, value, link }) => (
          <div key={label} style={styles.card}>
            <div style={styles.iconCircle}>
              <img src={icon} alt={label} style={styles.icon} />
            </div>
            <div style={styles.cardText}>
              <span style={styles.cardLabel}>{label}</span>
              {link ? (
                <a
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  style={styles.cardLink}
                >
                  {value}
                  <svg style={{ marginLeft: 4, verticalAlign: "middle" }} width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                    <polyline points="15 3 21 3 21 9"/>
                    <line x1="10" y1="14" x2="21" y2="3"/>
                  </svg>
                </a>
              ) : (
                <span style={styles.cardValue}>{value}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: 720,
    width: "100%",
    margin: "0 auto",
  },
  pageTitle: {
    fontSize: 26,
    fontWeight: 700,
    color: "#111",
    fontFamily: "Gilroy-Bold",
    marginBottom: 24,
  },
  grid: {
    display: "grid",
    gap: 16,
  },
  card: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    padding: "18px 20px",
    border: "1.5px solid #e0e0e0",
    borderRadius: 12,
    background: "#fff",
    transition: "border-color 0.15s, box-shadow 0.15s",
    cursor: "default",
  },
  iconCircle: {
    width: 48,
    height: 48,
    borderRadius: "50%",
    background: primaryLight,
    border: `1.5px solid ${primary}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  icon: {
    width: 24,
    height: 24,
    objectFit: "contain",
  },
  cardText: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },
  cardLabel: {
    fontSize: 13,
    color: "#888",
  },
  cardValue: {
    fontSize: 15,
    fontWeight: 600,
    color: "#111",
  },
  cardLink: {
    fontSize: 15,
    fontWeight: 600,
    color: primaryDark,
    textDecoration: "none",
  },
};

const Map = () => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  });
  const center = useMemo(() => ({ lat: 18.52043, lng: 73.856743 }), []);

  return (
    <div className="App">
      {!isLoaded ? (
        <h1>Cargando mapa...</h1>
      ) : (
        <GoogleMap mapContainerClassName="map-container" center={center} zoom={10}>
          <Marker position={{ lat: 18.52043, lng: 73.856743 }} />
        </GoogleMap>
      )}
    </div>
  );
};
